"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PricingModelType;
(function (PricingModelType) {
    // Unbekannt
    PricingModelType[PricingModelType["Unknown"] = 0] = "Unknown";
    // Pauschale
    PricingModelType[PricingModelType["FlatCharge"] = 1] = "FlatCharge";
    // Aufschlag
    PricingModelType[PricingModelType["Overvaluation"] = 2] = "Overvaluation";
    // Abschlag
    PricingModelType[PricingModelType["Undervaluation"] = 3] = "Undervaluation";
    // Fixpreis
    PricingModelType[PricingModelType["FixedPricing"] = 4] = "FixedPricing";
    // Kauf
    PricingModelType[PricingModelType["Purchase"] = 5] = "Purchase";
    // Kauf/Wiederbeschaffung
    PricingModelType[PricingModelType["PurchaseReplacement"] = 6] = "PurchaseReplacement";
})(PricingModelType = exports.PricingModelType || (exports.PricingModelType = {}));
exports.default = PricingModelType;
